const prefix = "nativeBroadcast";

export const messageTypes = {
  // Initialization
  INITIALIZED: `${prefix}:INITIALIZED`,

  CONSOLE_LOG: `${prefix}:CONSOLE_LOG`,

  // iOS
  FILE_CLOSE_AND_DELETE: `${prefix}:FILE_CLOSE_AND_DELETE`,
  FILE_CLOSE_AND_DELETE_IF_EMPTY: `${prefix}:FILE_CLOSE_AND_DELETE_IF_EMPTY`,
  EDIT_MODE_ENTERED: `${prefix}:EDIT_MODE_ENTERED`,
  EDIT_MODE_EXITED: `${prefix}:EDIT_MODE_EXITED`,

  // Mac/Windows
  UPGRADE_WIZARD_CANCELLED: `${prefix}:UPGRADE_WIZARD_CANCELLED`,

  // Windows - Window Controls
  CLOSE_WINDOW: `${prefix}:CLOSE_WINDOW`,
  MINIMIZE_WINDOW: `${prefix}:MINIMIZE_WINDOW`,
  MAXIMIZE_WINDOW: `${prefix}:MAXIMIZE_WINDOW`,

  // File Menu
  FILE_NEW: `${prefix}:FILE_NEW`,
  FILE_OPEN: `${prefix}:FILE_OPEN`,
  FILE_OPEN_RECENT: `${prefix}:FILE_OPEN_RECENT`,
  FILE_CLEAR_RECENT: `${prefix}:FILE_CLEAR_RECENT`,
  FILE_CLOSE: `${prefix}:FILE_CLOSE`,
  FILE_CLOSE_ALL: `${prefix}:FILE_CLOSE_ALL`,
  FILE_EXIT: `${prefix}:FILE_EXIT`,
  FILE_SAVE: `${prefix}:FILE_SAVE`,
  FILE_SAVE_AS: `${prefix}:FILE_SAVE_AS`,
  FILE_IMPORT_CSV: `${prefix}:FILE_IMPORT_CSV`,
  FILE_EXPORT_CSV: `${prefix}:FILE_EXPORT_CSV`,
  FILE_EXPORT_IMAGE: `${prefix}:FILE_EXPORT_IMAGE`,
  FILE_EXPORT_TSF: `${prefix}:FILE_EXPORT_TSF`,

  // Edit Menu
  EDIT_CUT: `${prefix}:EDIT_CUT`,
  EDIT_COPY: `${prefix}:EDIT_COPY`,
  EDIT_PASTE: `${prefix}:EDIT_PASTE`,

  // Welcome
  WELCOME_OPEN_EXISTING_FILE: `${prefix}:WELCOME_OPEN_EXISTING_FILE`,
  WELCOME_RECENT_FILE_OPENED: `${prefix}:WELCOME_RECENT_FILE_OPENED`,
  WELCOME_OPEN_EXAMPLE_FILE: `${prefix}:WELCOME_OPEN_EXAMPLE_FILE`,
  WELCOME_EXAMPLE_FILE_OPENED: `${prefix}:WELCOME_EXAMPLE_FILE_OPENED`,
  WELCOME_STANDARD_TEMPLATE_OPENED: `${prefix}:WELCOME_STANDARD_TEMPLATE_OPENED`,
  WELCOME_CUSTOM_TEMPLATE_OPENED: `${prefix}:WELCOME_CUSTOM_TEMPLATE_OPENED`,

  // Main App
  SETTINGS_OPENED: `${prefix}:SETTINGS_OPENED`,
  SETTINGS_CLOSED: `${prefix}:SETTINGS_CLOSED`,
  PREFERENCES_OPENED: `${prefix}:PREFERENCES_OPENED`,
  PREFERENCES_CLOSED: `${prefix}:PREFERENCES_CLOSED`,
  BACKUP_MODAL_OPENED: `${prefix}:BACKUP_MODAL_OPENED`,
  BACKUP_MODAL_CLOSED: `${prefix}:BACKUP_MODAL_CLOSED`,
  FILE_CONFLICT_MODAL_OPENED: `${prefix}:FILE_CONFLICT_MODAL_OPENED`,
  FILE_CONFLICT_MODAL_CLOSED: `${prefix}:FILE_CONFLICT_MODAL_CLOSED`,
  ABOUT_OPENED: `${prefix}:ABOUT_OPENED`,
  ABOUT_CLOSED: `${prefix}:ABOUT_CLOSED`,
  EXPORT_TSF_OPENED: `${prefix}:EXPORT_TSF_OPENED`,
  EXPORT_TSF_CLOSED: `${prefix}:EXPORT_TSF_CLOSED`,
  EXPORT_CSV_OPENED: `${prefix}:EXPORT_CSV_OPENED`,
  EXPORT_CSV_CLOSED: `${prefix}:EXPORT_CSV_CLOSED`,
  IMPORT_CSV_OPENED: `${prefix}:IMPORT_CSV_OPENED`,
  IMPORT_CSV_CLOSED: `${prefix}:IMPORT_CSV_CLOSED`,
  SAVE_TEMPLATE_OPENED: `${prefix}:SAVE_TEMPLATE_OPENED`,
  SAVE_TEMPLATE_CLOSED: `${prefix}:SAVE_TEMPLATE_CLOSED`,
  FILE_VERSION_OPENED: `${prefix}:FILE_VERSION_OPENED`,
  FILE_VERSION_CLOSED: `${prefix}:FILE_VERSION_CLOSED`,
  SAMPLE_OPENED: `${prefix}:SAMPLE_OPENED`,
  SAMPLE_CLOSED: `${prefix}:SAMPLE_CLOSED`,
  UPDATE_OPENED: `${prefix}:UPDATE_OPENED`,
  UPDATE_CLOSED: `${prefix}:UPDATE_CLOSED`,

  // Newly added
  APP_STATE_CHANGED: `${prefix}:APP_STATE_CHANGED`,
  FILE_CREATED: `${prefix}:FILE_CREATED`,
  PREFERENCES_CHANGED: `${prefix}:PREFERENCES_CHANGED`,
  SAMPLE_LOADED: `${prefix}:SAMPLE_LOADED`,

  // Attachments, links and images
  BROWSE_TO_ADD_ATTACHMENT: `${prefix}:BROWSE_TO_ADD_ATTACHMENT`,
  BROWSE_TO_ADD_IMAGE: `${prefix}:BROWSE_TO_ADD_IMAGE`,
  BROWSE_TO_ADD_IMAGE_FROM_PHOTOS: `${prefix}:BROWSE_TO_ADD_IMAGE_FROM_PHOTOS`,
  BROWSE_TO_ADD_LINK: `${prefix}:BROWSE_TO_ADD_LINK`,
  BROWSE_TO_ADD_IMAGE_LINK: `${prefix}:BROWSE_TO_ADD_IMAGE_LINK`,
  OPEN_EXTERNAL_LINK: `${prefix}:OPEN_EXTERNAL_LINK`,
  OPEN_ATTACHMENT: `${prefix}:OPEN_ATTACHMENT`,
  CONVERT_PATHS_TO_RELATIVE: `${prefix}:CONVERT_PATHS_TO_RELATIVE`,
  CONVERT_PATHS_TO_ABSOLUTE: `${prefix}:CONVERT_PATHS_TO_ABSOLUTE`,

  // Requesting browse window
  BROWSE_SYNC_FOLDER: `${prefix}:BROWSE_SYNC_FOLDER`,
  REQUEST_ULYSSES_TREE: `${prefix}:REQUEST_ULYSSES_TREE`,
  SYNC_RELOAD_REQUIRED: `${prefix}:SYNC_RELOAD_REQUIRED`,

  // Auto-backup
  BROWSE_BACKUP_FOLDER: `${prefix}:BROWSE_BACKUP_FOLDER`,
  OPEN_BACKUP_FOLDER: `${prefix}:OPEN_BACKUP_FOLDER`,

  // Sending data
  PUSH_DATA_TO_NATIVE: `${prefix}:PUSH_DATA_TO_NATIVE`,
  PUSH_SYNC_CONFIG_TO_NATIVE: `${prefix}:PUSH_SYNC_CONFIG_TO_NATIVE`,
  PUSH_TYPES_TO_NATIVE: `${prefix}:PUSH_TYPES_TO_NATIVE`,
  PUSH_MINDMAPS_TO_NATIVE: `${prefix}:PUSH_MINDMAPS_TO_NATIVE`,
  UPDATE_NATIVE_MENUS: `${prefix}:UPDATE_NATIVE_MENUS`,
  UPDATE_FONT_PERCENTAGE: `${prefix}:UPDATE_FONT_PERCENTAGE`,

  // Saving Custom Templates
  SAVE_CUSTOM_TEMPLATE_DATA: `${prefix}:SAVE_CUSTOM_TEMPLATE_DATA`,
  REQUEST_CUSTOM_TEMPLATE: `${prefix}:REQUEST_CUSTOM_TEMPLATE`,
  REQUEST_CUSTOM_TEMPLATE_INDEX: `${prefix}:REQUEST_CUSTOM_TEMPLATE_INDEX`,
  DELETE_CUSTOM_TEMPLATE: `${prefix}:DELETE_CUSTOM_TEMPLATE`,
  EXPORT_CUSTOM_TEMPLATE: `${prefix}:EXPORT_CUSTOM_TEMPLATE`,
  IMPORT_CUSTOM_TEMPLATE: `${prefix}:IMPORT_CUSTOM_TEMPLATE`,

  // Syncing
  UPDATE_EXTERNAL_SYNC: `${prefix}:UPDATE_EXTERNAL_SYNC`,

  // Printing Data
  PRINT_DATA: `${prefix}:PRINT_DATA`,
  REQUEST_PRINT_IMAGES: `${prefix}:REQUEST_PRINT_IMAGES`,

  // Exporting
  EXPORT_DATA_IMAGE: `${prefix}:EXPORT_DATA_IMAGE`,
  EXPORT_DATA_TSF: `${prefix}:EXPORT_DATA_TSF`,
  EXPORT_DATA_CSV: `${prefix}:EXPORT_DATA_CSV`,

  // Dialogs
  SHOW_ALERT_DIALOG: `${prefix}:SHOW_ALERT_DIALOG`,
  SHOW_OK_CANCEL_DIALOG: `${prefix}:SHOW_OK_CANCEL_DIALOG`,
  SHOW_YES_NO_DIALOG: `${prefix}:SHOW_YES_NO_DIALOG`,
  SHOW_YES_NO_CANCEL_DIALOG: `${prefix}:SHOW_YES_NO_CANCEL_DIALOG`,

  // Focus tracking
  FOCUS_CHANGED: `${prefix}:FOCUS_CHANGED`,

  // Auto Updates
  CHECK_FOR_UPDATE: `${prefix}:CHECK_FOR_UPDATE`,
  DOWNLOAD_UPDATE: `${prefix}:DOWNLOAD_UPDATE`,
  INSTALL_UPDATE_NOW: `${prefix}:INSTALL_UPDATE_NOW`,
  RELEASE_NOTES_READ: `${prefix}:RELEASE_NOTES_READ`,

  // Backups
  REQUEST_BACKUP_DATA: `${prefix}:REQUEST_BACKUP_DATA`,
  RESTORE_BACKUP: `${prefix}:RESTORE_BACKUP`,
  DELETE_ALL_BUT_LATEST_BACKUP_FOR_FILE: `${prefix}:DELETE_ALL_BUT_LATEST_BACKUP_FOR_FILE`,
  DELETE_ALL_BACKUPS_FOR_FILE: `${prefix}:DELETE_ALL_BACKUPS_FOR_FILE`,

  // Tutorials
  MARK_TUTORIAL_STEPS_COMPLETE: `${prefix}:MARK_TUTORIAL_STEPS_COMPLETE`,
  SILENCE_TUTORIAL: `${prefix}:SILENCE_TUTORIAL`,
  SHOW_HELP: `${prefix}:SHOW_HELP`,

  // Licensing and Trials
  SHOW_REGISTRATION_MODAL: `${prefix}:SHOW_REGISTRATION_MODAL`,
  RETRIEVE_WEBSITE_UPDATES: `${prefix}:RETRIEVE_WEBSITE_UPDATES`,
  USER_INITIATED_CHECK_FOR_LICENSED_UPDATE: `${prefix}:USER_INITIATED_CHECK_FOR_LICENSED_UPDATE`,

  // iOS Conflict Resolution
  RESOLVE_CONFLICT_CHOOSING_VERSIONS: `${prefix}:RESOLVE_CONFLICT_CHOOSING_VERSIONS`,
  CANCEL_CONFLICT_RESOLUTION: `${prefix}:CANCEL_CONFLICT_RESOLUTION`,

  // Reporting data
  ABOUT_COPY_TO_CLIPBOARD: `${prefix}:ABOUT_COPY_TO_CLIPBOARD`,

  // Analytics
  TRACK_EVENT: `${prefix}:TRACK_EVENT`
};

const getMsgHandler = () =>
  window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nativeCommsBroadcast
    ? window.webkit.messageHandlers.nativeCommsBroadcast
    : window.CefContainerInterface
      ? window.CefContainerInterface
      : null;

export const isNativeCommsInstalled = () => getMsgHandler() !== null;

export default data => {
  // See if a msgHandler has been installed
  const msgHandler = getMsgHandler();

  // If it has, send the message
  if (msgHandler) {
    msgHandler.postMessage(data);
  }
};
